import { AppSearchParams } from 'app-constants';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCookie } from 'react-use';

export const useGetAnalyticsCampaignParameters = () => {
  const [searchParams] = useSearchParams();
  const utm_name = searchParams.get(AppSearchParams.utmName) ?? '';
  const utm_source = searchParams.get(AppSearchParams.utmSource) ?? '';
  const utm_content = searchParams.get(AppSearchParams.utmContent) ?? '';
  const utm_medium = searchParams.get(AppSearchParams.utmMedium) ?? '';
  const utm_term = searchParams.get(AppSearchParams.utmTerm) ?? '';
  const gclid = searchParams.get(AppSearchParams.gclid) ?? '';

  const [gclidCookieValue] = useCookie('gclid');

  const parameters = useMemo(() => {
    const parameters: Record<string, string> = {};

    if (utm_name) parameters.name = utm_name;
    if (utm_source) parameters.source = utm_source;
    if (utm_content) parameters.content = utm_content;
    if (utm_medium) parameters.medium = utm_medium;
    if (utm_term) parameters.term = utm_term;
    if (gclid || gclidCookieValue) parameters.gclid = gclid;

    return parameters;
  }, [
    utm_name,
    utm_source,
    utm_content,
    utm_medium,
    utm_term,
    gclid,
    gclidCookieValue,
  ]);

  return parameters;
};
